import { render, staticRenderFns } from "./single-company.vue?vue&type=template&id=0d9aed92&"
import script from "./single-company.vue?vue&type=script&lang=js&"
export * from "./single-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports